/* MM Parity - WhatsApp, envio gratis, garantias y favoritos. 13/08/2026 */
(function () {
  'use strict';
  var CFG = window.MM_PARITY || {};
  var LIMITE = CFG.envioGratis || 6900;
  var KEY = 'mm_favoritos';

  var ICO = {
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.19 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0012.04 2z"/></svg>',
    tel: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57a1 1 0 01-.25 1.02l-2.2 2.2z"/></svg>',
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.55 11.48L12 20.3z"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>',
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 12a8.5 8.5 0 1 0 2.9-6.4"/><path d="M3.5 4v5h5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>'
  };

  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + '\u00A0\u20AC'; }
  function nodo(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function limpia(s) { return String(s || '').split(String.fromCharCode(34)).join(''); }
  function primero(sels) {
    for (var i = 0; i < sels.length; i++) { var n = document.querySelector(sels[i]); if (n) return n; }
    return null;
  }
  function toast(html) {
    var t = nodo('div', 'mm-toast');
    t.innerHTML = html;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }

  /* ---------- 1. Contacto (desactivado) ---------- */
  function contacto() {
    /* MM v13: sin botones de teléfono ni WhatsApp por decisión de Álvaro (no se publica ningún teléfono). El contacto va por el formulario flotante .mmc de layout/theme.liquid. */
    return;
  }

  /* ---------- 2. Barra de envio gratis ---------- */
  function pintaBarras(total) {
    var falta = LIMITE - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / LIMITE) * 100)));
    var txt = falta > 0
      ? 'Te faltan <strong>' + euros(falta) + '</strong> para el <strong>env\u00EDo gratis</strong>'
      : 'Enhorabuena, tu pedido tiene <strong>env\u00EDo gratis</strong>';
    var html = '<div class="mm-ship__text">' + txt + '</div><div class="mm-ship__track"><div class="mm-ship__fill" style="width:' + pct + '%"></div></div>';
    var bs = document.querySelectorAll('.mm-ship');
    for (var i = 0; i < bs.length; i++) {
      bs[i].innerHTML = total > 0 ? html : '';
      bs[i].setAttribute('data-done', total >= LIMITE ? '1' : '0');
    }
  }

  function creaBarras() {
    var cajon = primero(['cart-drawer-component', '#cart-drawer', '[id*=CartDrawer]']);
    if (cajon && !cajon.querySelector('.mm-ship')) {
      var host = cajon.querySelector('.cart-drawer__content, .drawer__inner, .cart-items, form') || cajon;
      host.insertBefore(nodo('div', 'mm-ship'), host.firstChild);
    }
    if (location.pathname.indexOf('/cart') === 0) {
      var main = document.getElementById('MainContent');
      if (main && !main.querySelector('.mm-ship')) main.insertBefore(nodo('div', 'mm-ship mm-ship--page'), main.firstChild);
    }
  }

  var pidiendo = false;
  function refresca() {
    if (pidiendo) return;
    pidiendo = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { creaBarras(); pintaBarras(c.total_price || 0); })
      .catch(function () {})
      .then(function () { pidiendo = false; });
  }

  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var p = fetchOriginal.apply(this, arguments);
    try {
      var a = arguments[0];
      var u = typeof a === 'string' ? a : (a && a.url) || '';
      if (u.indexOf('/cart/') !== -1) p.then(function () { setTimeout(refresca, 300); });
    } catch (e) {}
    return p;
  };
  ['cart:update', 'cart:refresh', 'CartUpdateEvent'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresca, 120); });
  });

  /* ---------- 3. Garantias en la ficha de producto ---------- */
  var GARANTIAS = CFG.garantiasTexto || [
    ['truck', 'Env\u00EDo gratis desde 69\u00A0\u20AC', 'Pen\u00EDnsula, entrega en 24-72\u00A0h'],
    ['shield', '30 a\u00F1os cuidando mascotas', 'Tienda espa\u00F1ola, atenci\u00F3n en espa\u00F1ol'],
    ['back', 'Devoluci\u00F3n en 14 d\u00EDas', 'Si no encaja, lo cambiamos o te devolvemos el dinero'],
    ['lock', 'Pago 100\u00A0% seguro', 'Tus datos siempre cifrados']
  ];

  function garantias(ancla) {
    if (document.querySelector('.mm-reassurance')) return;
    var g = nodo('div', 'mm-reassurance');
    var h = '';
    for (var i = 0; i < GARANTIAS.length; i++) {
      h += '<div class="mm-reassurance__item">' + (ICO[GARANTIAS[i][0]] || '') +
        '<div><span class="mm-reassurance__t">' + GARANTIAS[i][1] + '</span><span class="mm-reassurance__s">' + GARANTIAS[i][2] + '</span></div></div>';
    }
    g.innerHTML = h;
    ancla.insertAdjacentElement('afterend', g);
  }

  /* ---------- 4. Favoritos ---------- */
  function leeFav() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function guardaFav(l) {
    try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, 60))); } catch (e) {}
  }
  function estaFav(h) {
    var l = leeFav();
    for (var i = 0; i < l.length; i++) if (l[i].handle === h) return true;
    return false;
  }

  function botonFav(ancla) {
    var p = CFG.producto;
    if (!p || document.querySelector('.mm-wish')) return;
    var b = nodo('button', 'mm-wish');
    b.type = 'button';
    function pinta() {
      var on = estaFav(p.handle);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.innerHTML = ICO.heart + '<span>' + (on ? 'En tus favoritos' : 'A\u00F1adir a favoritos') + '</span>';
    }
    b.addEventListener('click', function () {
      var l = leeFav();
      var idx = -1;
      for (var i = 0; i < l.length; i++) if (l[i].handle === p.handle) idx = i;
      if (idx >= 0) { l.splice(idx, 1); guardaFav(l); pinta(); return; }
      l.unshift(p);
      guardaFav(l);
      pinta();
      toast('Guardado en favoritos. <a href="/pages/favoritos">Ver mis favoritos</a>');
    });
    pinta();
    ancla.insertAdjacentElement('afterend', b);
  }

  function pintaFavoritos() {
    var raiz = document.getElementById('mm-favoritos');
    if (!raiz && location.pathname.indexOf('/pages/favoritos') === 0) {
      var main = document.getElementById('MainContent');
      if (!main) return;
      raiz = nodo('div');
      raiz.id = 'mm-favoritos';
      main.appendChild(raiz);
    }
    if (!raiz) return;
    var l = leeFav();
    if (!l.length) {
      raiz.innerHTML = '<p class="mm-wish-empty">Todav\u00EDa no has guardado ning\u00FAn producto. Pulsa el coraz\u00F3n en cualquier ficha para guardarlo aqu\u00ED.</p>';
      return;
    }
    var h = '<div class="mm-wish-grid">';
    for (var i = 0; i < l.length; i++) {
      var p = l[i];
      var img = p.imagen ? '<a href="' + limpia(p.url) + '"><img loading="lazy" src="' + limpia(p.imagen) + '" alt="' + limpia(p.titulo) + '"></a>' : '';
      h += '<div class="mm-wish-card" data-handle="' + limpia(p.handle) + '">' +
        '<button class="mm-wish-card__x" type="button" aria-label="Quitar de favoritos">&times;</button>' + img +
        '<div class="mm-wish-card__b"><a class="mm-wish-card__t" href="' + limpia(p.url) + '">' + limpia(p.titulo) + '</a>' +
        '<span class="mm-wish-card__p">' + euros(p.precio || 0) + '</span></div></div>';
    }
    raiz.innerHTML = h + '</div>';
    var xs = raiz.querySelectorAll('.mm-wish-card__x');
    for (var k = 0; k < xs.length; k++) {
      xs[k].addEventListener('click', function (ev) {
        var handle = ev.currentTarget.parentNode.getAttribute('data-handle');
        guardaFav(leeFav().filter(function (x) { return x.handle !== handle; }));
        pintaFavoritos();
      });
    }
  }

  /* ---------- arranque ---------- */
  function init() {
    contacto();
    refresca();
    pintaFavoritos();
    if (CFG.producto) {
      var compra = primero(['product-form-component', '.product-form-buttons', '[class*=buy-buttons]', '.shopify-payment-button', 'product-form']);
      if (compra) { garantias(compra); botonFav(compra); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();